import React from 'react';

function Map() {
  return (
    <section className="tc-map-style1">
      <div className="map-card wow zoomIn slow" data-wow-delay="0.2s">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3183.6438077922007!2d37.3529439!3d37.0659705!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1531e1863dcf7631%3A0x8390d2851bf28c21!2sAt%C3%B6lye%20Line!5e0!3m2!1str!2str!4v1750634460393!5m2!1str!2str"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>

      </div>
    </section>
  );
}

export default Map;
